import { Injectable } from '@angular/core';
import { castArray } from '@sama/micro-dash';
import { InjectableSuperclass } from '@sama/ng-core';
import { Object3D, Scene } from 'three';

@Injectable()
export class SceneControllerService extends InjectableSuperclass {
  private scene = new Scene();

  getScene() {
    return this.scene;
  }

  addToScene(meshOrMeshes: Object3D[] | Object3D) {
    const meshes = castArray(meshOrMeshes);
    for (const mesh of meshes) {
      this.scene.add(mesh);
    }
  }

  removeFromScene(meshOrMeshes: Object3D[] | Object3D) {
    const meshes = Array.isArray(meshOrMeshes) ? meshOrMeshes : [meshOrMeshes];
    this.scene.remove(...meshes);
  }
}
